import { Action } from "@ngrx/store/src/models";
import { ActionBase } from "../../../core/store/action/ActionBase";

export const ACTION_ERROR = '[Pillar] Action Error';

export class ActionError implements Action {
  readonly type: string;
  payload: { action: ActionBase, errors: string[] };

  constructor(action: ActionBase, errors: string[]) {
    this.type = ACTION_ERROR;
    this.payload = {
      action: action,
      errors: errors
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pillar/common/actions/ActionError.ts